"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Wrench, Snowflake, Wind, Flame } from "lucide-react";
const services = [{
  id: 1,
  icon: Wrench,
  title: "System Design & Installation",
  description: "Custom HVAC solutions tailored to your commercial building's unique requirements and energy goals."
}, {
  id: 2,
  icon: Snowflake,
  title: "Commercial Cooling",
  description: "High-capacity air conditioning systems ensuring optimal comfort and productivity year-round."
}, {
  id: 3,
  icon: Wind,
  title: "Ventilation Solutions",
  description: "Advanced ventilation systems improving indoor air quality and maintaining healthy work environments."
}, {
  id: 4,
  icon: Flame,
  title: "Commercial Heating",
  description: "Efficient heating systems providing reliable warmth and comfort throughout the coldest months."
}];
export default function CommercialServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-dark-background text-foreground-dark py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`bg-muted-light-background text-foreground-muted-light border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : i === 2 ? "animate-fade-in-up-delay-200" : "opacity-0 animate-fade-in-up" : "opacity-0"} ${i === 3 ? "animation-delay-[300ms]" : ""}`} style={i === 3 && isVisible ? {
            animationDelay: "300ms",
            opacity: 1
          } : undefined}>
                <CardContent className="pt-6 flex flex-col items-center text-center aspect-square justify-between">
                  <div className="w-full flex flex-col items-center gap-4 flex-1 justify-center">
                    <div className="rounded-full bg-primary/10 p-4">
                      <Icon className="size-8 text-primary" aria-hidden="true" />
                    </div>
                    <h3 className="font-display text-lg font-bold text-foreground-muted-light">
                      {service.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </CardContent>
                <CardFooter className="pb-6 pt-0 justify-center">
                  <Button asChild variant="outline" size="sm" className="hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                    <Link to="#">Learn More</Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}